import { connect } from "react-redux";
import * as React from "react";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { useTourElementsRegistry } from "../../Internals/TourManagement/TourElementsRegistryContext";
import { useExternalEventManager } from "../../FormObjectProvider";

import { Tour } from "./Tour";

const mapStateToProps = (state: FullFormState) => ({
    shownTours: state.settings.shownTours,
    isFormInFormNds: state.settings.isFormInFormNds,
    isDisabledTour: Boolean(state.settings.isDisabledTour),
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    dispatch: dispatch,
});

export const TourConnected = connect(mapStateToProps, mapDispatchToProps)(Tour);

export function TourContainer(props?: Record<string, unknown>): JSX.Element {
    const tourElementsRegistry = useTourElementsRegistry();
    const externalEventManager = useExternalEventManager();
    return (
        <TourConnected
            {...props}
            externalEventManager={externalEventManager}
            tourElementsRegistry={tourElementsRegistry}
        />
    );
}
